import React from 'react';
import PropTypes from 'prop-types';

import { debounce } from 'lodash';

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import * as api from '_core/utils/api';
import { withLang } from '_core/hocs/withLang';


export default withLang(class extends React.Component { // https://v4.mui.com/ru/api/autocomplete/
  
  static propTypes = {
  };
  
  static defaultProps = {
    disableClearable: true,
    limit: 5
  };
  
  
  constructor(props) {
    super(props);
    
    this.state = {
      input: '',
      value: null,
      list: []
    };
  }
  
  
  buildLocalityValue = (locality) => locality.value.toReversed().join(', ');
  
  value = null;
  
  setValue = debounce((value) => {
    const {
      getLangString: l,
      langInfo
    } = this.props;
    
    
    value = Number(value);
    
    if (!value || this.value === value)
      return;
    
    this.value = value;
    
    if (this.state.value?.id === value)
      return;
    
    api.getAddressLocality(langInfo?.code || 'en', value)
      .then((map) => {
        const item = map[value];
        
        this.setState((state) => ({
          ...state,
          
          input: item && this.buildLocalityValue(item) || '',
          list: item ? [item] : [],
          value: item || null
        }));
      })
      .catch((error) => console.error(error));
  }, 100);
  
  onChange = debounce((value) => {
    const {
      getLangString: l,
      langInfo,
      
      limit
    } = this.props;
    
    if (value) {
      this.setState((state) => ({ ...state, value: null }));
      
      api.getAddressLocalitySuggest(langInfo?.code || 'en', value, limit)
        .then((list) => this.setState((state) => ({
          ...state,
          
          list: list || [],
          value: list.length && list[0] || null
        })))
        .catch((error) => {
          console.error(error);
          
          this.setState((state) => ({ ...state, list: [] }));
        });
    } else if (value !== 0) {
      this.setState((state) => ({
        ...state,
        
        list: [],
        value: null
      }));
    }
  }, 100);
  
  onInputChange = (event, input) => {
    this.setState((state) => ({
      ...state,
      
      input
    }));
    
    this.onChange(input);
  };
  
  
  componentDidMount() {
    const { value } = this.props;
    
    
    this.setValue(this.props.value);
  }
  
  componentWillUnmount() {
  }
  
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { value, onChange } = this.props;
    
    
    this.setValue(value);
    
    if (prevState.value?.id === this.state.value?.id)
      return;
    
    if (typeof onChange === 'function')
      onChange(this.state.value);
  }
  
  render() {
    const {
      disableClearable,
      
      ...props
    } = this.props;
    
    delete props.value;
    delete props.onChange;
    delete props.limit;
    
    
    return (
      <Autocomplete
        freeSolo
        disableClearable={disableClearable}
        autoSelect={false}
        
        options={this.state.list}
        inputValue={this.state.input}
        
        getOptionLabel={(option) => option.value ? this.buildLocalityValue(option) : option}
        getOptionSelected={(option, value) => option.id === value.id}
        filterOptions={(option, value) => option}
        renderInput={(inputProps) => (
          <TextField
            {...props}
            {...inputProps}
          />
        )}
        
        onInputChange={this.onInputChange}
        onChange={(event, value, reason) => this.setState((state) => ({ ...state, value }))}
      />
    );
  }
  
});
